import axiosClient from './axiosClient';
import { IProfile, IStudent } from '~/utils/interface/profile';
import { IBaseResponse, IListDataResponseCanvas } from '~/utils/interface/base';
import { urlApiUser } from '~/utils/constants/apis';
import { ContentTypeEnum } from '~/utils/enum/common';
import { IPayloadUpdateUsers, IQueryGetStudent } from '~/utils/interface/account';
import {
  IDiscussionForumProgress,
  IExamProgress,
  IQueryGetStudentProgressPage,
  IStudentProgressPage,
  IVideoLectureProgress,
} from '~/utils/interface/studentProgress';

export const userApi = {
  getProfile() {
    const url = `${urlApiUser.getList}`;
    return axiosClient.get<IBaseResponse<IProfile>>(url);
  },

  updateProfile(body: FormData) {
    const url = `${urlApiUser.updateProfile}`;

    return axiosClient.put<IBaseResponse<{ avatarUrl: string }>>(url, body, {
      headers: { 'Content-Type': ContentTypeEnum.FORM_DATA },
    });
  },

  getStudents(params: IQueryGetStudent) {
    const url = `${urlApiUser.getStudents}`;
    const { isGetAll, ...restParams } = params;
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<IStudent[]>>>(url, { params: restParams });
  },

  updateUsers(payload: IPayloadUpdateUsers) {
    return axiosClient.put<IBaseResponse<any>>(urlApiUser.base, payload);
  },

  getStudentVideoLectures(studentId: string, params: IQueryGetStudentProgressPage) {
    const url = urlApiUser.getStudentVideoLectures(studentId);
    return axiosClient.get<IBaseResponse<IStudentProgressPage<IVideoLectureProgress>>>(url, { params });
  },

  getStudentDiscussionForums(studentId: string, params: IQueryGetStudentProgressPage) {
    const url = urlApiUser.getStudentDiscussionForums(studentId);
    return axiosClient.get<IBaseResponse<IStudentProgressPage<IDiscussionForumProgress>>>(url, { params });
  },

  getStudentExams(studentId: string, params: IQueryGetStudentProgressPage) {
    const url = urlApiUser.getStudentExams(studentId);
    return axiosClient.get<IBaseResponse<IStudentProgressPage<IExamProgress>>>(url, { params });
  },
};
